export const URI_TAG = 'template/module/tag';
export const URI_TAG_AVAILABLE = (id: string) => `template/module/${id}/tag`;
